module.exports = __webpack_public_path__ + "21673925c253a75f2cc24f4fce12a3f8.png";